// @ts-ignore
import { ChartCovConfig } from '@asa_xbt/binary-chart/lib/cov/util';

export function getChartConfig(locale: string): ChartCovConfig {
  return {
    isMobile: false,
    paddingTop: 55,
    paddingBottom: 35,
    locale,
    minValue: 0,
    isAxis: true,
    isInteractive: true,
    // !!! dont touch comments here, its important to realise whats going on !!!
    theme: {
      strokeLineJoin: 'round',
      closesLineWidth: 2.5, // line width
      accent: '#0a0a0a', // tooltip price color
      inactive: '#717172', // tick color and tooltip date color
      deepBg: '#fff', // tooltip background color
      // trend colors
      up: '#24a95d',
      down: '#ff4b40',
      action: '#3760ff',
      warn: '#ffc36a',
      lightBg: '#e2e2e2', // grid color
      bg: '#fff', // point color
      pulse: '#ffffff', // no needed
    },
  };
}
